export enum DialogStep {
  Type = 'type',
  Pages = 'pages',
}
